module.exports = __webpack_public_path__ + "img/logoutIcon.e8b54a67.svg";